import React, { useState } from 'react';
import { LayoutGrid } from 'lucide-react';
import { InfoBox, InputGroup } from '../Common';

const DistTool = () => {
    const [input, setInput] = useState('10, -5, 15, -10, 20, 5, -2');
    const arr = input.split(',').map(ss => parseFloat(ss)).filter(nn => !isNaN(nn));
    
    const w = arr.filter(n => n > 0);
    const l = arr.filter(n => n <= 0);
    const aw = w.length ? w.reduce((a, b) => a + b, 0) / w.length : 0;
    const al = l.length ? l.reduce((a, b) => a + b, 0) / l.length : 0;
    const wr = arr.length ? (w.length / arr.length) * 100 : 0;

    return (
        <div className="tct-tool-container">
            <div className="tct-panel-title">Trade Distribution Analyzer</div>
            <p style={{ color: 'var(--text2)', fontSize: '13px', marginBottom: '20px' }}>Enter results separated by commas.</p>
            <textarea 
                className="ant-input" 
                style={{ width: '100%', minHeight: '80px', background: 'var(--surface2)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: '8px', padding: '12px' }}
                value={input}
                onChange={(e) => setInput(e.target.value)}
            />
            <div className="tct-results-grid mt-4">
                <div className="tct-card tct-blue">
                    <div className="tct-data-row"><span className="tct-label">Win Rate</span><span className="tct-value">{wr.toFixed(1)}%</span></div>
                    <div className="tct-data-row"><span className="tct-label">Avg Win</span><span className="tct-value val-green">{aw.toFixed(1)} pts</span></div>
                    <div className="tct-data-row"><span className="tct-label">Avg Loss</span><span className="tct-value val-red">{al.toFixed(1)} pts</span></div>
                </div>
            </div>
            <InfoBox
                title="Understanding Trade Distribution in Trading Strategies"
                meta="Trade distribution analysis helps traders understand how profits and losses are distributed across trades"
                sections={[
                { title: "Introduction", content: "Trade distribution shows whether profits come from:<br>• many small wins<br>• a few large wins<br>• consistent gains.<br><br>Understanding this helps traders evaluate strategy stability." }
                ]}
            />
        </div>
    );
};

export default DistTool;
